import { isString } from 'mathjs';
import Action from '../../classes/Action';
import AssetUtility from '../../classes/AssetUtility';
import MaterialAsset from '../../classes/MaterialAsset';
import store, { StoreActions } from '../../state/store';
import { AssetTypes } from '../../globals';
import AssetsManager from '../../classes/AssetsManager';

export default class ReplaceVideoAsset extends Action
{
	constructor(oldAssetId: string, newAssetId: string)
	{
		const oldAssetName = AssetUtility.getAssetName(oldAssetId);
		const newAssetName = AssetUtility.getAssetName(newAssetId);
		const actionName = "Replaced " + oldAssetName + " References With " + newAssetName;
		super([oldAssetId, newAssetId], [newAssetId, oldAssetId], actionName, [oldAssetId, newAssetId]);
	}

	do(oldAssetId: string, newAssetId: string) : void
	{
		for (const materialAsset of MaterialAsset.materialAssetBank.values())
		{
			if (materialAsset['video'] && materialAsset['video'].userData.assetId === oldAssetId)
			{
				materialAsset.handleChange('video', newAssetId, false);

				// update redux manually
				store.dispatch(StoreActions.material.setMaterialProperty({
					id: materialAsset.guid,
					value: newAssetId,
					property: 'video',
					shouldSubmit: false
				}));
			}
		}

		store.dispatch(StoreActions.ui.replaceAsset({ oldId: oldAssetId, newId: newAssetId }));
	}

	verify(oldAssetId: string, newAssetId: string): boolean
	{
		return 	oldAssetId !== newAssetId && 
				isString(oldAssetId) && isString(newAssetId) &&
				AssetsManager.getAssetInfo(oldAssetId)?.type === AssetTypes.Video && 
				AssetsManager.getAssetInfo(newAssetId)?.type === AssetTypes.Video;
	}
}
